import "core-js/modules/es.function.name.js";
import React from 'react';
import FontAwesome from 'react-fontawesome';
import ReactTooltip from 'react-tooltip';
import { isEmpty } from 'lodash';
import { SidebarToken, Status } from "./styles";
import StatusWidget from "./StatusWidget";
import { _ab_color } from "../../../../components/style";
import { capitalize } from '@applyboard/ui-utils';
import { getApplicationStatus, ApplicationStatus as ApplicationStatusValues, AcceptanceStatus, PaymentStatus, getAcceptanceStatus, getPaymentStatus } from "../../../../util/common";
var ApplicationStatus = function ApplicationStatus(_ref) {
  var className = _ref.className,
    application = _ref.application;
  var acceptanceStatus = processAcceptanceStatus(getAcceptanceStatus(application));
  var applicationStatus = processApplicationStatus(getApplicationStatus(application), application);
  var paid = getPaymentStatus(application) === PaymentStatus.Paid;
  var paymentStatus = processPaymentStatus({
    paid: paid,
    acceptanceStatus: acceptanceStatus,
    applicationStatus: applicationStatus
  });
  return /*#__PURE__*/React.createElement("div", {
    className: className,
    "data-cy": "sidebar-application-status"
  }, acceptanceStatus && (acceptanceStatus.status === 'accepted' ? /*#__PURE__*/React.createElement("span", {
    style: {
      color: _ab_color.green
    }
  }, /*#__PURE__*/React.createElement("span", {
    role: "img",
    "aria-label": "Accepted"
  }, /*#__PURE__*/React.createElement(FontAwesome, {
    name: "check"
  })), /*#__PURE__*/React.createElement(StatusWidget, {
    status: acceptanceStatus
  })) : /*#__PURE__*/React.createElement("span", {
    style: {
      color: _ab_color.red
    }
  }, acceptanceStatus.name === 'times' && /*#__PURE__*/React.createElement("span", {
    role: "img",
    "aria-label": "Rejected"
  }, /*#__PURE__*/React.createElement(FontAwesome, {
    name: "times"
  })), /*#__PURE__*/React.createElement(StatusWidget, {
    status: acceptanceStatus
  }))), applicationStatus && /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'flex',
      flexDirection: 'column'
    }
  }, /*#__PURE__*/React.createElement(SidebarToken, {
    key: applicationStatus.key,
    status: applicationStatus.status
  }, applicationStatus.applicationStatusTooltipMessage && /*#__PURE__*/React.createElement(ReactTooltip, {
    id: "".concat(applicationStatus.key, "-tooltip")
  }, applicationStatus.applicationStatusTooltipMessage), applicationStatus.name && /*#__PURE__*/React.createElement("span", {
    "data-for": "".concat(applicationStatus.key, "-tooltip"),
    "data-tip": true
  }, /*#__PURE__*/React.createElement("span", {
    role: "img",
    "aria-label": "In Progress"
  }, /*#__PURE__*/React.createElement(FontAwesome, {
    name: applicationStatus.name
  }))), /*#__PURE__*/React.createElement(Status, null, getLabelForStatus(applicationStatus.status)))), paymentStatus && /*#__PURE__*/React.createElement(StatusWidget, {
    status: paymentStatus
  }));
};
var getLabelForStatus = function getLabelForStatus(status) {
  if (status === 'refund_in_progress') {
    return 'Refund in Progress';
  }
  if (status === 'deferral_in_progress') {
    return 'Deferral in Progress';
  }
  return capitalize(status);
};
var processAcceptanceStatus = function processAcceptanceStatus(retrievedAcceptanceStatus) {
  var returnAcceptanceStatus = {};
  if (retrievedAcceptanceStatus === AcceptanceStatus.Accepted) {
    returnAcceptanceStatus.key = 'sb-status-accepted';
    returnAcceptanceStatus.status = 'accepted';
    returnAcceptanceStatus.name = 'check';
  }
  if (retrievedAcceptanceStatus === AcceptanceStatus.Rejected) {
    returnAcceptanceStatus.key = 'sb-status-rejected';
    returnAcceptanceStatus.status = 'rejected';
    returnAcceptanceStatus.name = 'times';
  }
  if (retrievedAcceptanceStatus === AcceptanceStatus.WaitListed) {
    returnAcceptanceStatus.key = 'sb-status-waitlisted';
    returnAcceptanceStatus.status = 'waitlisted';
    returnAcceptanceStatus.name = null;
  }
  if (retrievedAcceptanceStatus === AcceptanceStatus.ProgramClosed) {
    returnAcceptanceStatus.key = 'sb-status-program-closed';
    returnAcceptanceStatus.status = 'program_closed';
    returnAcceptanceStatus.name = null;
  }
  return isEmpty(returnAcceptanceStatus) ? null : returnAcceptanceStatus;
};
var processApplicationStatus = function processApplicationStatus(retrievedApplicationStatus, application) {
  if (isEmpty(retrievedApplicationStatus)) {
    return null;
  }
  var returnApplicationStatus = {};
  if (retrievedApplicationStatus === ApplicationStatusValues.RefundInProgress) {
    returnApplicationStatus.key = 'sb-status-refund-in-progress';
    returnApplicationStatus.status = 'refund_in_progress';
    returnApplicationStatus.name = 'hourglass-end';
  } else if (retrievedApplicationStatus === ApplicationStatusValues.DeferralInProgress) {
    returnApplicationStatus.key = 'sb-status-deferral-in-progress';
    returnApplicationStatus.status = 'deferral_in_progress';
    returnApplicationStatus.name = 'hourglass-end';
  } else if (retrievedApplicationStatus === ApplicationStatusValues.Withdrawn) {
    returnApplicationStatus.key = 'sb-status-withdrawn';
    returnApplicationStatus.status = 'withdrawn';
    returnApplicationStatus.name = 'exclamation-triangle';
    returnApplicationStatus.applicationStatusTooltipMessage = application.cancellation_reason === 'Other' ? application.cancellation_additional_note : application.cancellation_reason;
  } else if (retrievedApplicationStatus === ApplicationStatusValues.Cancelled) {
    returnApplicationStatus.key = 'sb-status-canceled';
    returnApplicationStatus.status = 'canceled';
    returnApplicationStatus.name = 'exclamation-triangle';
    returnApplicationStatus.applicationStatusTooltipMessage = application.cancellation_reason === 'Other' ? application.cancellation_additional_note : application.cancellation_reason;
  }
  return returnApplicationStatus;
};
var processPaymentStatus = function processPaymentStatus(params) {
  var paid = params.paid,
    acceptanceStatus = params.acceptanceStatus,
    applicationStatus = params.applicationStatus;
  var returnPaymentStatus = {};
  if (isEmpty(acceptanceStatus) && isEmpty(applicationStatus)) {
    if (paid) {
      returnPaymentStatus.key = 'sb-status-processing';
      returnPaymentStatus.status = 'processing';
      returnPaymentStatus.name = 'hourglass-end';
    } else {
      returnPaymentStatus.key = 'sb-status-pending';
      returnPaymentStatus.status = 'pending';
      returnPaymentStatus.name = 'shopping-cart';
    }
  }
  return isEmpty(returnPaymentStatus) ? null : returnPaymentStatus;
};
export default ApplicationStatus;